var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.235 4.953C2.96004 6.27629 2.1795 7.99815 2.02457 9.82917C1.86964 11.6602 2.34977 13.4887 3.38426 15.0074C4.41874 16.5261 5.94451 17.6424 7.70511 18.1686C9.46571 18.6948 11.3538 18.5989 13.052 17.897C13.167 17.147 12.915 16.427 12.812 16.175C12.582 15.615 11.824 14.658 10.559 13.331C10.221 12.976 10.243 12.703 10.364 11.894L10.377 11.803C10.459 11.249 10.597 10.921 12.462 10.625C13.41 10.475 13.659 10.853 14.004 11.378L14.12 11.55C14.448 12.03 14.691 12.14 15.058 12.306C15.223 12.381 15.428 12.476 15.703 12.631C16.355 13.004 16.355 13.425 16.355 14.347V14.452C16.355 14.843 16.317 15.187 16.257 15.486C17.0244 14.5229 17.5591 13.3957 17.8196 12.1922C18.0801 10.9886 18.0593 9.74122 17.7588 8.54703C17.4584 7.35284 16.8863 6.2441 16.0873 5.30714C15.2883 4.37017 14.2838 3.63026 13.152 3.145C12.599 3.518 11.84 4.047 11.575 4.41C11.44 4.595 11.248 5.542 10.625 5.62C10.463 5.64 10.244 5.626 10.012 5.611C9.39 5.571 8.54 5.516 8.268 6.255C8.095 6.723 8.065 7.995 8.624 8.655C8.714 8.76 8.731 8.955 8.67 9.174C8.59 9.461 8.429 9.636 8.378 9.672C8.282 9.616 8.09 9.393 7.959 9.242C7.646 8.877 7.254 8.422 6.748 8.282C6.564 8.231 6.362 8.189 6.165 8.147C5.616 8.032 4.995 7.901 4.85 7.593C4.744 7.367 4.745 7.056 4.745 6.728C4.745 6.311 4.745 5.84 4.541 5.383C4.47008 5.21991 4.36585 5.07344 4.235 4.953ZM10 20.5C4.477 20.5 0 16.023 0 10.5C0 4.977 4.477 0.5 10 0.5C15.523 0.5 20 4.977 20 10.5C20 16.023 15.523 20.5 10 20.5Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobe);
export default __webpack_public_path__ + "static/media/Icon_Globe.b887c919f540ace01661e335d18f6b48.svg";
export { ForwardRef as ReactComponent };